/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaptureSummary } from './CaptureSummary';
import {
    CaptureSummaryFromJSON,
    CaptureSummaryFromJSONTyped,
    CaptureSummaryToJSON,
    CaptureSummaryToJSONTyped,
} from './CaptureSummary';

/**
 * 
 * @export
 * @interface ListCapturesResponse
 */
export interface ListCapturesResponse {
    /**
     * 
     */
    captures: Array<CaptureSummary>;
    /**
     * 
     */
    truncated: boolean;
}

/**
 * Check if a given object implements the ListCapturesResponse interface.
 */
export function instanceOfListCapturesResponse(value: object): value is ListCapturesResponse {
    if (!('captures' in value) || value['captures'] === undefined) return false;
    if (!('truncated' in value) || value['truncated'] === undefined) return false;
    return true;
}

export function ListCapturesResponseFromJSON(json: any): ListCapturesResponse {
    return ListCapturesResponseFromJSONTyped(json, false);
}

export function ListCapturesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListCapturesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'captures': ((json['captures'] as Array<any>).map(CaptureSummaryFromJSON)),
        'truncated': json['truncated'],
    };
}

export function ListCapturesResponseToJSON(json: any): ListCapturesResponse {
    return ListCapturesResponseToJSONTyped(json, false);
}

export function ListCapturesResponseToJSONTyped(value?: ListCapturesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'captures': ((value['captures'] as Array<any>).map(CaptureSummaryToJSON)),
        'truncated': value['truncated'],
    };
}

